import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=78290186&scoped=true&"
import script from "./page2.vue?vue&type=script&lang=js&"
export * from "./page2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78290186",
  null
  
)

component.options.__file = "page2.vue"
export default component.exports